import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  AccountBankAccountDto,
  CreateBankAccountRequest,
  UpdateBankAccountRequest
} from '../../models/bank-account.model';

/**
 * Admin client for an account's bank accounts on file.
 * Responses are masked (last four only).
 */
@Injectable({ providedIn: 'root' })
export class AccountBankingService {
  private baseUrl = `${environment.apiUrl}/api/admin/accounts`;

  constructor(private http: HttpClient) {}

  list(accountId: number): Observable<AccountBankAccountDto[]> {
    return this.http.get<AccountBankAccountDto[]>(`${this.baseUrl}/${accountId}/bank-accounts`);
  }

  create(accountId: number, body: CreateBankAccountRequest): Observable<AccountBankAccountDto> {
    return this.http.post<AccountBankAccountDto>(`${this.baseUrl}/${accountId}/bank-accounts`, body);
  }

  update(accountId: number, id: number, body: UpdateBankAccountRequest): Observable<AccountBankAccountDto> {
    return this.http.put<AccountBankAccountDto>(`${this.baseUrl}/${accountId}/bank-accounts/${id}`, body);
  }

  remove(accountId: number, id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${accountId}/bank-accounts/${id}`);
  }

  setDefault(accountId: number, id: number): Observable<AccountBankAccountDto> {
    return this.http.post<AccountBankAccountDto>(`${this.baseUrl}/${accountId}/bank-accounts/${id}/set-default`, {});
  }
}
